/**
 * DynListHandle — opens the value list of a constrained dynamic block property
 * (visibility states, preset sizes), the equivalent of AutoCAD's triangular grip.
 */

import { HandleType, HANDLE_SIZES } from "../types";
import { DynPickHandle } from "./DynPickHandle";
import type { DynBlockPickKind } from "../../blocks/dynPickBus";

/** Same blue family as the flip handle, slightly darker to read as "opens a menu". */
const DYN_LIST_DRAW_OPTIONS = {
  fillColor: [40, 100, 190] as [number, number, number],
  strokeColor: [255, 255, 255] as [number, number, number],
  // Downward triangle: AutoCAD's visibility/lookup grip.
  shape: "triangleDown" as const,
  radius: HANDLE_SIZES.default * HANDLE_SIZES.handleScale,
};

export class DynListHandle extends DynPickHandle {
  readonly type = HandleType.DynList;
  protected readonly kind: DynBlockPickKind = "list";

  // A subclass field initializer runs after super(), so this wins over the default
  // set in AbstractHandle.
  drawOptions = { ...DYN_LIST_DRAW_OPTIONS };
}
